import { ProgramStatusType } from '@services/communities';

export interface IProgramParams {
  published?: boolean;
  archived?: boolean;
  gcrEnabled?: boolean;
  status?: ProgramStatusType;
  clientId?: string;
}
